<template>
    <div class="content__positioning distancing text input-forms-size" style="top: 10%;">
        <div class="signup__adv">
        <div class="headlin-text">Hello, welcome to Adway!</div>
        <div style="padding-top: 3%; padding-bottom: 3%;">To start using Adway please complete your profile</div>
        <div class="input-area" aria-autocomplete="off">
            <div class="input-field-area">
                <div>What is your first name?</div>
                <input class="input-filed" type="text" placeholder="eg. Jane" v-model="firstname">
            </div>
            <div class="input-field-area">
              <div>What is your last name?</div>
              <input class="input-filed" type="text" placeholder="eg. Doe" v-model="surname">
            </div>
            <div class="input-field-area">
                <div>What is your company’s name?</div>
                <input class="input-filed" type="text" name="" placeholder="eg. my company 1" v-model="companyName">
            </div>
            <div class="input-field-area">
                <div>What is your email?</div>
                <input class="input-filed" type="text" name="" placeholder="eg. myemail@myemail.com" v-model="email">
            </div>
            <div class="input-field-area">
                <div>What is your phone number?</div>
                <input class="input-filed" type="text" name="" placeholder="eg. 123-456-7890" v-model="phone" maxlength="50">
            </div>
            <div class="input-field-area">
                <div>What is your company’s website?</div>
                <input class="input-filed" type="text" name="" placeholder="eg. mycompany.com" v-model="companyWebSite">
            </div>
            <div class="check-boxs">
                <div>
                  <input type="checkbox" name="TermsAndConditions" id="advertiser-ts" v-model="termsAndConditionsCB">
                  <label for="TermsAndConditions">I agree with </label><router-link class="external-view" to="/advertisertc" style="color: black;">Advertiser terms and conditions</router-link>
                </div>
                <div>
                  <input type="checkbox" name="adway-notification" id="adway-notification" v-model="notificationCB">
                  <label for="adway-notification">I want to receive Adway's campaign notifications</label>
                </div>
            </div>
            <div class="button__container style__container" v-if="!isMobile()">
                <button class="adway-btn-2-class cancel__button" @click="$router.go(-1)" style="margin-bottom: 15px;">
                    <span class="btn__text__normal">Cancel</span>
                </button>
                <vue-recaptcha :sitekey='keys.googleRecaptcheSiteKey' :loadRecaptchaScript="true" v-if="!isDebug()">
                  <button @click="submit" class="adway-btn-class submit" style="margin-bottom: 15px;">
                    <clip-loader :loading="creatingAccountRequestSpinner" :color="'#fff'"></clip-loader>
                    <div v-if="!creatingAccountRequestSpinner" class="btn__context">
                      <span class="btn__text__bold" style="padding-right: 5px;">Finish</span>
                      <img class="left__arrow__style" src="./../../../../assets/right-arrow.png" alt="left arrow">
                    </div>
                  </button>
                </vue-recaptcha>
                <button @click="submit" class="adway-btn-class submit" style="margin-bottom: 15px;" v-if="isDebug()">
                  <clip-loader :loading="creatingAccountRequestSpinner" :color="'#fff'"></clip-loader>
                  <div v-if="!creatingAccountRequestSpinner" class="btn__context">
                    <span class="btn__text__bold" style="padding-right: 5px;">Finish</span>
                    <img class="left__arrow__style" src="./../../../../assets/right-arrow.png" alt="left arrow">
                  </div>
                </button>
            </div>
            <div class="button__container style__container" v-else>
              <vue-recaptcha :sitekey='keys.googleRecaptcheSiteKey' :loadRecaptchaScript="true">
                <button @click="submit" class="adway-btn-class submit" style="margin-bottom: 15px;">
                  <clip-loader :loading="creatingAccountRequestSpinner" :color="'#fff'"></clip-loader>
                  <div v-if="!creatingAccountRequestSpinner" class="btn__context">
                    <span class="btn__text__bold" style="padding-right: 5px;">Finish</span>
                    <img class="left__arrow__style" src="./../../../../assets/right-arrow.png" alt="left arrow">
                  </div>
                </button>
              </vue-recaptcha>
              <button class="adway-btn-2-class cancel__button" @click="$router.go(-1)" style="margin-bottom: 15px;">
                <span class="btn__text__normal">Cancel</span>
              </button>
            </div>
        </div>
    </div>
     </div>
</template>

<script>
import HTTPRequest from './../../../../plugins/utils/HttpRequest.js'
import Config from './../../../../plugins/utils/Config.js'
// import VueRecaptcha from 'vue-recaptcha'
import toast from '@utils/toast.js'
import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
import store from "@store";
import { mapGetters } from "vuex"

export default {
  name: 'AdvertiserFormView',
  components: {
      // VueRecaptcha
      ClipLoader
  },
  data: function () {
    return {
      profileUpdateStatus: "in-progress",
      profileUpdateError: null,
      profileUpdateResult: null,
      email: '',
      companyName: '',
      phone: '',
      companyWebSite: '',
      firstname: '',
      surname: '',
      termsAndConditionsCB: false,
      notificationCB: false,
      // config: Config,
      response: null,
      creatingAccountRequestSpinner: false,
      config: Config,
      mounted: false,
      preloaded: false,
    }
  },
  mounted() {
    this.mounted = true;
  },
  computed: {
    ...mapGetters({
      keys: 'keys'
    }),
    readyToPreaload: function() {
      return this.mounted && !this.$auth.loading && this.$auth.isAuthenticated;
    }
  },
  watch: {
    profileUpdateStatus: function(newValue, oldValue) {
      if (newValue === "error") {
        toast.errorMessage(profileUpdateError.message);
      } else if (newValue === "success") {
        this.$router.push({ path: "/driver/account" });
        toast.successMessage("Profile updated");
      }
    },
    readyToPreaload: function(newValue, oldValue) {
      if (newValue && !this.preloaded) {
        const profile = store.getters.getUser;
        this.firstname = profile.firstname || this.$auth.user.name;
        this.surname = profile.surname || this.$auth.user.family_name;
        this.email = profile.email || this.$auth.user.email;
        this.phone = profile.phone;
        this.companyWebSite = profile.website;
        this.companyName = profile.company;
        this.notificationCB = profile.ADWAY_notifications;
        this.preloaded = true;
      }
    },
  },
  methods: {
    submit () {
      const errors = [];
      if (this.emailCheck()) {
        errors.push(`Email field is empty`);
      } else if (!this.emailValidation()) {
        errors.push(`Email is not valid`);
      }
      if (!this.termsAndConditionsCB) {
        errors.push('Terms and condictions is not checked');
      }
      // if (!this.firstname) errors.push(`First name field is empty`);
      // if (!this.surname) errors.push(`Surname name field is empty`);
      if (errors.length) {
        toast.errorMessage(errors.join("<br>"));
      } else {
        this.updateProfile()
      }
    },
    emailCheck () {
      return !this.email;
    },
    emailValidation () {
      if (!this.email.includes('@') || this.email.includes('@.')) {
        return false
      } else {
        return true
      }
    },
    async updateProfile() {
      this.profileUpdateStatus = "in-progress";
      this.profileUpdateError = null;
      this.profileUpdateResult = null;

      var body = {
        user: this.$auth.user.sub,
        API_KEY: this.keys.api_key,
        data: {
          auth0: this.$auth.user,
          firstname: this.firstname,
          surname: this.surname,
          email: this.email,
          phone: this.phone,
          website: this.companyWebSite,
          company: this.companyName,
          ADWAY_notifications: this.notificationCB ? 1 : 0
        }
      }

      try {
        var response = await this.request('/set/profile', 'POST', body);
        if (response.code === 0) {
          this.profileUpdateResult = response;
          this.profileUpdateStatus = "success";
          return response;
        } else {
          this.profileUpdateError = response.message;
        }
      } catch(error) {
        this.profileUpdateError = error.message;
      }
      this.profileUpdateStatus = "error";
    },
    getUser () {
      return this.email
    }
  }
}
</script>

<style scoped>
.submit {
  width: auto;
  padding: 0 40px 0 20px;
}
.btn__context{
  padding: 0px calc(50% - 81px) 0px calc(50% - 81px);
  position: relative;
}
.button__container {
  display: flex;
}
.left__arrow__style {
  position: relative ;
    margin-left: 100%;
    width: 19px;
    display: inline;
    margin-top: -16px;
}

@media only screen and (max-width: 600px) {
  .left__arrow__style{
    margin-left: 15px;
  }
}
</style>
